import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { Box, Grid, TextField, Typography, Stack } from "@mui/material";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../../../utilities/CustomDatePicker";
import moment from "moment";
import AgGridTable from "../../../utilities/AgGridTable";
import { useNavigate } from "react-router-dom";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import TotalStatus from "./TotalStatus";
import { useMemo } from "react";

const AddLinkToCustomer = forwardRef((props, ref) => {
    const gridRef = useRef();
    const navigate = useNavigate();
    const [fromError, setFromError] = useState();
    const [toError, setToError] = useState();
    const [rowData, setRowData] = useState([]);
    const [saveDisable, setSaveDisable] = useState(true);
    const [editLinktoCustomerData, setEditLinktoCustomerData] = useState();
    const [companyNameOptions, setCompanyNameOptions] = useState([]);
    const [lcListOptions, setLcListOptions] = useState([]);
    const [orderCategoriesOptions, setOrderCategoriesOptions] = useState([
        { label: 'RETAIL', value: 'RETAIL' },
        { label: 'PROJECT', value: 'PROJECT' },
    ]);
    const [paymentCodesOptions, setPaymentCodeOptions] = useState([]);
    const [conditionOptions, setConditionsOptions] = useState([
        { label: 'BOOKING ALLOWED', value: 'BOOKING ALLOWED' },
        { label: 'BOOKING & RELEASING ALLOWED', value: 'BOOKING & RELEASING ALLOWED' },
        { label: 'BOOKING & RELEASING NOT ALLOWED', value: 'BOOKING & RELEASING NOT ALLOWED' },
    ]);
    const [successMsg, setSuccessMsg] = useState();
    const [linkToCustomerData, setLinkToCustomerData] = useState({
        company: "",
        companyName: '',
        orderType: '',
        validFrom: "",
        validTo: "",
        paymentTerm: '',
        condition: 'BOOKING ALLOWED',
        booking: true,
        releasing: false,
        approved: true,
        creditLimit: 0,
        creditBalance: 0,
        projectName: '',
        lcNumber: ''
    })
    const [columnDefs, setColumnDefs] = useState([
        { field: 'day', headerName: 'Day', minWidth: 150, },
        { field: 'type', headerName: 'Base On', minWidth: 150, },
        { field: 'rate', headerName: 'Rate', minWidth: 150, },
        { field: 'description', headerName: 'Description', minWidth: 150, },
    ])
    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerm + '/linkToCustomer'}`;
    const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
    const paymentCodeurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerms}`;
    const paymentlinkCustomerurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTermLinkToCustomers}`;


    useEffect(() => {
        const getCompany = async () => {
            const types = await OAuthService.getList(companyUrl + '/search/findByActive?active=true');
            let companyName = types?.data?._embedded?.companies.map((type) => {

                return { label: type.name, value: type.name, id: type.id }
            });
            if (companyName && companyName.length > 0) {
                setCompanyNameOptions(companyName)
            }
        }
        const getPaymentCode = async () => {
            const types = await OAuthService.getList(`${paymentCodeurl}?size=2000`);
            let paymenTerm = types?.data?._embedded?.paymentTerms.map((type) => {
                return { label: type.code + ' ' +  type.paymentCondition, value: type.id, paymentCondition: type.paymentCondition, paymentInstallmentList: type.paymentInstallmentList }
            });
            if (paymenTerm && paymenTerm.length > 0) {
                setPaymentCodeOptions(prev => [...prev, ...paymenTerm])
            }
        }

        const lcNoList = async () => {
            const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredit}`;
            const list = await OAuthService.getList(lcUrl + '/getAllLcNumbers');
            if (list?.data) {
                const lcNo = list?.data?.map((val) => {

                    return { label: val, value: val }
                });
                if (lcNo.length > 0) {
                    setLcListOptions(lcNo)
                }
            }
        }
        lcNoList();

        getCompany();
        // getorderCategories();
        getPaymentCode(0)

        if (props.linkedId) {
            getEditData();
        }
    }, []);

    const getEditData = async () => {
        try {
            if (props.linkedId) {
                const editData = await OAuthService.getEditData(paymentlinkCustomerurl, props.linkedId);
                if (editData?.data) {
                    let obj = { ...editData?.data }
                    if (obj.booking && obj.releasing) {
                        obj = { ...obj, condition: 'BOOKING & RELEASING ALLOWED' }
                    } else if (obj.booking && !obj.releasing) {
                        obj = { ...obj, condition: 'BOOKING ALLOWED' }
                    } else if (!obj.booking && !obj.releasing) {
                        obj = { ...obj, condition: 'BOOKING & RELEASING NOT ALLOWED' }
                    }
                    const company = await OAuthService.getList(paymentlinkCustomerurl + `/${obj?.id}/company`);
                    // const company = await OAuthService.getList(obj?._links?.company?.href);
                    if (company?.data) {
                        obj = { ...obj, company: company?.data?.id.toString() }
                    }
                    // const paymentTerm = await OAuthService.getList(obj?._links?.paymentTerm?.href);
                    const paymentTerm = await OAuthService.getList(paymentlinkCustomerurl + `/${obj?.id}/paymentTerm`);
                    if (paymentTerm?.data) {
                        obj = { ...obj, paymentTerm: paymentTerm?.data?.id, paymentTermDesc: paymentTerm?.data?.paymentCondition }
                        setRowData(paymentTerm?.data?.paymentInstallmentList)
                    }
                    delete obj?._links
                    setLinkToCustomerData(obj)

                    setEditLinktoCustomerData(JSON.parse(JSON.stringify(obj)))
                }
            }
        } catch (error) {

        }
    }

    const handleSubmit = async () => {
        let model = {
            ...linkToCustomerData
        }
        delete model.name;
        delete model.paymentTermDesc;
        delete model.condition;
        
        try {
            if (props.linkedId) {
                delete model.createdAt;
                delete model.createdBy;
                delete model.updatedAt;
                delete model.updatedBy;
                await OAuthService.updateData(url + '/update', '', model);
                setSuccessMsg('Payment term link to Partner updated successfully.')
                return 'Payment term link to Partner updated successfully.';
            } else {
                await OAuthService.addData(url + '/save', [model, {...model,orderType: model.orderType === 'RETAIL' ? ' PROJECT' : 'RETAIL' }]);
                setSuccessMsg('Payment term link to Partner added successfully.')
                return 'Payment term link to Partner added successfully.';
            }
        } catch (error) {

        }
    }

    const handleFromDateChange = (value) => {
        value && setLinkToCustomerData({ ...linkToCustomerData, validFrom: value === null ? null : moment(value).format('YYYY-MM-DD'), validTo: null })
    }

    const handleToDateChange = async (value) => {
        const endDate = value === null ? null : moment(value).format('YYYY-MM-DD');
        setLinkToCustomerData({ ...linkToCustomerData, validTo: value === null ? null : moment(value).format('YYYY-MM-DD') })
            (!linkToCustomerData.validFrom && endDate) ? setFromError('Please select from date ') : setFromError('');
    }

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }))

    const handleComapnyNameChange = (data) => {
        setLinkToCustomerData({ ...linkToCustomerData, companyName: data.value, company: data.id.toString() })
    }
    const handlePaymenTermChange = (data) => {
        setLinkToCustomerData({ ...linkToCustomerData, paymentTerm: data.value, paymentTermDesc: data?.paymentCondition });
        setRowData(data?.paymentInstallmentList)
    }

    const handleOrderTypeChange = (data) => {
        setLinkToCustomerData({ ...linkToCustomerData, orderType: data.value })
    }
    const handleConditionChange = (data) => {
        if (data.value === 'BOOKING & RELEASING NOT ALLOWED') {
            setLinkToCustomerData({ ...linkToCustomerData, booking: false, releasing: false, condition: data.value })
        } else if (data.value === 'BOOKING ALLOWED') {
            setLinkToCustomerData({ ...linkToCustomerData, booking: true, releasing: false, condition: data.value })
        } else if (data.value === 'BOOKING & RELEASING ALLOWED') {
            setLinkToCustomerData({ ...linkToCustomerData, booking: true, releasing: true, condition: data.value })
        }
    }

    const handleCreditLimitChange = (event) => {
        setLinkToCustomerData({ ...linkToCustomerData, creditLimit: Number(event.target.value) })
    }

    const handleCreditBalanceChange = (event) => {
        setLinkToCustomerData({ ...linkToCustomerData, creditBalance: Number(event.target.value) })
    }

    const statusBar = useMemo(() => {
        return {
          statusPanels: [
            {
              statusPanel: TotalStatus,
            },
          ],
        };
      }, []);

    useEffect(() => {
        if(linkToCustomerData.company && linkToCustomerData.creditBalance && linkToCustomerData.creditLimit && linkToCustomerData.orderType && 
            linkToCustomerData.paymentTerm && linkToCustomerData.validFrom && linkToCustomerData.validTo && linkToCustomerData.condition ){
                if(linkToCustomerData.orderType === 'PROJECT'){
                    if(linkToCustomerData.projectName){
                        if(props.linkedId){
                            if(JSON.stringify(linkToCustomerData) === JSON.stringify(editLinktoCustomerData)){
                                setSaveDisable(true)
                            }else{
                                setSaveDisable(false)
                            }
                        }else{
                            setSaveDisable(false)
                        }
                    }else{
                        setSaveDisable(true)
                    }
                }else{
                    if(props.linkedId){
                        if(JSON.stringify(linkToCustomerData) === JSON.stringify(editLinktoCustomerData)){
                            setSaveDisable(true)
                        }else{
                            setSaveDisable(false)
                        }
                    }else{
                        setSaveDisable(false)
                    }
                }
            }else{
                setSaveDisable(true)
            }

    },[linkToCustomerData,editLinktoCustomerData])

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    useEffect(() => {
        props.saveDisabled(saveDisable)
    }, [saveDisable]);

    const handleProjectNumberChange = (event) => {
        setLinkToCustomerData({ ...linkToCustomerData, projectName: event.target.value })
    }
    const handleLcChange = (event) => {
        setLinkToCustomerData({ ...linkToCustomerData, lcNumber: event.value })
    }

    return (
        <>
            <div>
                <Box className="m-5 p-20" sx={{ border: '1px dashed grey' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack className="mt-8">
                                <label className="min-w-fit">Partner Number</label>
                                <TextField
                                    value={linkToCustomerData.company}
                                    name="customer"
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={5}>
                            <Stack className="mt-8">
                                <label className="min-w-fit">Partner Name*</label>
                                <Select
                                    name="name"
                                    className=" min-w-[150px]"
                                    value={(linkToCustomerData.companyName && companyNameOptions.length > 0) && companyNameOptions.filter((list) => list.value === linkToCustomerData.companyName)}
                                    onChange={handleComapnyNameChange}
                                    isDisabled={props.linkedId ? true : false}
                                    options={companyNameOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack className="mt-8">
                                <label className="min-w-fit">Order Type*</label>
                                <Select
                                    name="orderType"
                                    className="min-w-fit"
                                    value={(linkToCustomerData.orderType && orderCategoriesOptions.length > 0) && orderCategoriesOptions.filter((list) => list.value === linkToCustomerData.orderType)}
                                    onChange={handleOrderTypeChange}
                                    isDisabled={props.linkedId ? true : false}
                                    options={orderCategoriesOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">From* </label>
                                <div className="grid">
                                    <CustomDatePicker
                                        className="h-[20px]"
                                        format={'dd-MM-yyyy'}
                                        name={'fromDate'}
                                        value={linkToCustomerData.validFrom}
                                        maxDate={new Date(linkToCustomerData.validTo)}
                                        handleChange={handleFromDateChange}
                                        componentsProps={{
                                            actionBar: { actions: ["clear"] },
                                        }}
                                        renderInput={(params) => <TextField size="small" InputLabelProps={{
                                        }} {...params} sx={{
                                            backgroundColor: props.viewData && '#8080800f'
                                        }} />}
                                    />
                                    <p className="text-red">{(fromError && !linkToCustomerData.validFrom) && fromError}</p>
                                </div>
                            </Stack>
                        </Grid>

                        <Grid item xs={3}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">To*</label>
                                <div className="grid">
                                    <CustomDatePicker
                                        className=" h-[20px]"
                                        format={'dd-MM-yyyy'}
                                        name={'toDate'}
                                        value={linkToCustomerData.validTo}
                                        minDate={new Date(linkToCustomerData.validFrom)}
                                        handleChange={handleToDateChange}
                                        componentsProps={{
                                            actionBar: { actions: ["clear"] },
                                        }}
                                        renderInput={(params) => <TextField size="small" InputLabelProps={{
                                        }} {...params} sx={{
                                            backgroundColor: props.viewData && '#8080800f'
                                        }} />}
                                    />
                                    <p className="text-red">{(toError && !linkToCustomerData.validTo) && toError}</p>
                                </div>
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Credit Limit*</label>
                                <TextField
                                    value={linkToCustomerData.creditLimit}
                                    name="creditLimit"
                                    onChange={handleCreditLimitChange}
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Credit Balance*</label>
                                <TextField
                                    value={linkToCustomerData.creditBalance}
                                    onChange={handleCreditBalanceChange}
                                    name="creditBalance"
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Payment Term*</label>
                                <Select
                                    name="name"
                                    className=" min-w-[150px]"
                                    value={(linkToCustomerData.paymentTerm && paymentCodesOptions.length > 0) && paymentCodesOptions.filter((list) => list.value === linkToCustomerData.paymentTerm)}
                                    onChange={handlePaymenTermChange}
                                    options={paymentCodesOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>

                        <Grid item xs={7}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Payment Description</label>
                                <TextField
                                    name="description"
                                    value={linkToCustomerData.paymentTermDesc}
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}
                                />
                            </Stack>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Condition*</label>
                                <Select
                                    name="condition"
                                    className=" min-w-[150px]"
                                    value={(linkToCustomerData.condition && conditionOptions.length > 0) && conditionOptions.filter((list) => list.value === linkToCustomerData.condition)}
                                    onChange={handleConditionChange}
                                    // isMulti={true}
                                    options={conditionOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>
                        {linkToCustomerData.orderType === "PROJECT" &&
                        <>
                        <Grid item xs={4}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">Project Number*</label>
                                <TextField
                                    name="projectName"
                                    value={linkToCustomerData.projectName}
                                    onChange={handleProjectNumberChange}
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>

                        <Grid item xs={4}>
                            <Stack className="mt-16">
                                <label className="min-w-fit">LC Number</label>
                                <Select
                                    name="lc-number "
                                    className=" min-w-[150px]"
                                    value={(linkToCustomerData.lcNumber && lcListOptions.length > 0) && lcListOptions.filter((list) => linkToCustomerData.lcNumber === list.value)}
                                    onChange={handleLcChange}
                                    options={lcListOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>
                        </>
                        }
                    </Grid>

                </Box>
                <Grid container>
                    <Grid item xs={12} className="h-[250px] mt-20">
                        <Typography className="text-lg">Installments</Typography>
                        <AgGridTable
                            columnDefs={columnDefs}
                            rowData={rowData}
                            gridRef={gridRef}
                            floatingFilter={false}
                            editable={false}
                            rowGroupPanelShow='never'
                            statusBar={statusBar}
                        />
                        {/* <div className="flex justify-end items-baseline m-8 ">
                            <label className="mr-8 min-w-fit" >Total</label>
                            <TextField
                                name="total"
                                //value=
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }} />
                        </div> */}
                    </Grid>
                </Grid>
            </div>
        </>
    )
})
export default AddLinkToCustomer